import { render, staticRenderFns } from "./DashboardContiSend.vue?vue&type=template&id=00bc25ae&scoped=true"
import script from "./DashboardContiSend.vue?vue&type=script&lang=js"
export * from "./DashboardContiSend.vue?vue&type=script&lang=js"
import style0 from "./DashboardContiSend.vue?vue&type=style&index=0&id=00bc25ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bc25ae",
  null
  
)

export default component.exports